import { Button, Grid, Stack, Typography } from "@mui/material";
import {
  AIGovernanceIcon,
  DownloadingTipsIcon,
  HealthImmunizationIcon,
  PlayLandingPageIcon,
  SanitationIcon,
  StayUpdatedIcon,
  TargetTipsIcon,
  UserMapIcon,
} from "../../@lib/icons";
import { Link } from "react-router-dom";
import { FAQ } from "./FAQ";
import { FooterPublic, Navbar, useLanguageTranslator } from "../../components";
import { WhyUs } from "./whyUs";
import { OurServices } from "./ourServices";
import "./styles.css";

function LandingPage() {
  const { translator } = useLanguageTranslator();

  return (
    <div>
      <Navbar />
      <Stack
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        mt={10}
      >
        <img src="/assets/images/logo.png" alt="logo" width="300" height="80" />
        <Typography
          variant="h1"
          sx={{
            fontSize: {
              xs: "2.6rem",
            },
          }}
          className="landing-page-text"
          fontWeight={"400"}
        >
          {translator("landingPage.Change Never Sleeps.")}
        </Typography>
        <div style={{ display: "flex" }}>
          <Typography
            variant="h1"
            fontWeight={"700"}
            className="landing-page-text"
          >
            {translator("landingPage.Neither")}
          </Typography>
          <Typography
            variant="h1"
            color={"#F6A000"}
            ml={1}
            className="landing-page-text"
          >
            {translator("landingPage.Do We")}
          </Typography>
          <Typography variant="h1" color={"#00AAB0"}>
            .
          </Typography>
        </div>
        <Typography variant="h6" className="landing-page-hero-sub-text">
          {translator(
            "landingPage.The first African tracking tool to support your advocacy management"
          )}
        </Typography>
        <Typography variant="h6">
          {translator("landingPage.with precise, real-time data.")}
        </Typography>
        <Link
          to="/dashboard"
          style={{
            backgroundColor: "#F6A000",
            padding: "8px 12px",
            color: "white",
            borderRadius: "10px",
            fontSize: "14px",
            marginTop: "12px",
            textDecoration: "none",
          }}
        >
          {translator("landingPage.Let's Start")}
        </Link>
        <Stack
          my={6}
          sx={{
            border: "1px solid #fbe9c8",
            borderRadius: "10px",
            display: "flex",
            width: "93%",
          }}
          mr={10}
          ml={10}
          py={3}
        >
          <Stack
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h3"
              mb={2}
              className="landing-page-question-sub-text"
            >
              {translator("landingPage.What is The Niyel Tracker?")}
            </Typography>
            {/* <Typography variant="h5" color={"#494E54"} fontWeight={"400"}>
              {translator(
                "landingPage.Change never sleeps, and neither do we. The Niyel Tracker is the first African tracking tool to support your advocacy"
              )}
            </Typography> */}
            {/* <Typography variant="h5" color={"#494E54"} fontWeight={"400"}>
              {translator(
                "landingPage.management with precise, real-time data. It is your go-to resource for staying informed and adapting to the ever-"
              )}
            </Typography> */}
            <Typography variant="h5" color={"#494E54"} fontWeight={"400"}>
              {translator(
                "landingPage.It is your go-to resource for staying informed and adapting to the ever-"
              )}
            </Typography>
            <Typography variant="h5" color={"#494E54"} fontWeight={"400"}>
              {translator(
                "landingPage.evolving landscape of policies and practices across Africa."
              )}
            </Typography>
            <Typography
              variant="h5"
              color={"#494E54"}
              mt={3}
              fontWeight={"400"}
            >
              {translator(
                "landingPage.A dynamic tool designed to provide real-time insights into shifting policies, practices, and influential people in"
              )}
            </Typography>
            <Typography variant="h5" color={"#494E54"} fontWeight={"400"}>
              {translator(
                "landingPage.countries across Africa, the Niyel Tracker empowers advocates, funders, policymakers, and change-makers"
              )}
            </Typography>
            <Typography variant="h5" color={"#494E54"} fontWeight={"400"}>
              {translator(
                "landingPage.with the information to make strategic decisions."
              )}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Grid container mt={3} px={5}>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <div>
            <UserMapIcon className="user-map-icon" />
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={6} xl={6}>
          <Typography variant="h3">
            {" "}
            {translator("landingPage.Our Initial Areas of Focus")}
          </Typography>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <Typography
                variant="h4"
                sx={{ display: "flex", alignItems: "end" }}
              >
                <div style={{ marginRight: "8px" }}>
                  <SanitationIcon />
                </div>
                {translator("landingPage.Sanitation")}
              </Typography>
              <Typography variant="h6" color={"#494E54"} fontWeight={"400"}>
                {translator(
                  "landingPage.From Senegal to Uganda, we monitor policies and practices that impact clean water and sanitation efforts."
                )}
              </Typography>
              <Typography
                variant="h4"
                sx={{ display: "flex", alignItems: "end" }}
                mt={2}
              >
                <div style={{ marginRight: "8px" }}>
                  <AIGovernanceIcon />
                </div>
                {translator("landingPage.Data Governance and AI")}
              </Typography>
              <Typography variant="h6" color={"#494E54"} fontWeight={"400"}>
                {translator(
                  "landingPage.In Benin, Burkina Faceo, and Senegal, we provide insights on the regulation and ethical use of data and artificial intelligence."
                )}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <Typography
                variant="h4"
                sx={{ display: "flex", alignItems: "end" }}
              >
                <div style={{ marginRight: "8px" }}>
                  <HealthImmunizationIcon />
                </div>
                {translator("landingPage.Health & Immunization")}
              </Typography>
              <Typography variant="h6" color={"#494E54"} fontWeight={"400"}>
                {translator(
                  "landingPage.In Nigeria and the DRC, we track health policies and immunization initiatives that protect communities."
                )}
              </Typography>
            </Grid>
          </Grid>
          <Typography variant="h6" color={"#494E54"} fontWeight={"400"} mt={3}>
            {translator(
              "landingPage.But we are not stopping there. As we expand our goal is to cover every SDG and provide a comprehensive understanding of the entire continents policy and practice landscape."
            )}
          </Typography>
        </Grid>
      </Grid>

      <WhyUs translator={translator} />
      <section id="about-us">
        <Stack
          sx={{
            background: "linear-gradient(to right, #FFC352 0%, #F7A40A 100%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "30px",
            mx: {
              xs: 2,
              sm: 4,
              md: 7,
              lg: 7,
              xl: 7,
            },
          }}
          px={8}
          py={5}
          mb={10}
        >
          <Button
            sx={{
              backgroundColor: "#fbc763",
              color: "white",
              fontSize: "16px",
              borderRadius: "0px",
              padding: "5px 15px",
            }}
          >
            {translator("navbar.About Us")?.toUpperCase()}
          </Button>
          <Typography
            variant="h5"
            color={"white"}
            fontWeight={"500"}
            mt={2}
            mx={{ xs: 1, sm: 4, md: 7, lg: 10, xl: 10 }}
            textAlign="center"
          >
            {translator(
              "landingPage.At Niyel, advocacy is at the heart of everything we do. The Niyel Tracker is an extension of our mission to inspire, enable, and"
            )}{" "}
            {translator(
              "landingPage.create change. By providing real-time insights into policies, practices, and influential networks, the Tracker empowers"
            )}{" "}
            {translator(
              "landingPage.our partners and fellow advocates and enhances our own effectiveness in driving impactful change. It is a tool that"
            )}{" "}
            {translator(
              "landingPage.embodies our commitment to collective action and serves as a catalyst for informed, strategic advocacy across Africa."
            )}
          </Typography>
          <Typography
            variant="h5"
            color={"white"}
            fontWeight={"500"}
            mt={2}
            mx={{ xs: 1, sm: 4, md: 7, lg: 10, xl: 10 }}
            textAlign="center"
          >
            {translator(
              "landingPage.Niyel is an African-owned and led advocacy organization, grounded on the continent and driven by a deep understanding of"
            )}{" "}
            {translator(
              "landingPage.Africa’s ever-evolving policy landscape. We are committed to harnessing the power of local talent and innovative"
            )}{" "}
            {translator(
              "landingPage.technology to create meaningful, sustainable change."
            )}
          </Typography>
          {/* <Typography variant="h3" color={"white"} mt={3}>
            {translator("landingPage.The Niyel Tracker")}
          </Typography>
          <Typography variant="h5" color={"white"} fontWeight={"500"} mt={2}>
            {translator(
              "landingPage.At Niyel, advocacy is at the heart of everything we do. The Niyel Tracker is an extension of our mission to inspire, enable, and"
            )}
          </Typography>
          <Typography variant="h5" color={"white"} fontWeight={"500"}>
            {translator(
              "landingPage.create change. By providing real-time insights into policies, practices, and influential networks, the Tracker empowers"
            )}
          </Typography>
          <Typography variant="h5" color={"white"} fontWeight={"500"}>
            {translator(
              "landingPage.our partners and fellow advocates and enhances our effectiveness in driving impactful change. It is a tool that"
            )}
          </Typography>
          <Typography variant="h5" color={"white"} fontWeight={"500"}>
            {translator(
              "landingPage.embodies our commitment to collective action and serves as a catalyst for informed, strategic advocacy across Africa."
            )}
          </Typography>
          <Typography variant="h5" color={"white"} fontWeight={"500"} mt={2}>
            {translator(
              "landingPage.Niyel is an African-owned and led advocacy organization, grounded on the continent and driven by a deep understanding of"
            )}
          </Typography>
          <Typography variant="h5" color={"white"}>
            {translator(
              "landingPage.Africa’s ever-evolving policy landscape. We are committed to harnessing the power of local talent and innovative"
            )}
          </Typography>
          <Typography variant="h5" color={"white"}>
            {translator(
              "landingPage.technology to create meaningful, sustainable change."
            )}
          </Typography> */}
        </Stack>
      </section>
      <section id="our-focus">
        <OurServices translator={translator} />
      </section>
      <section id="FAQ">
        <FAQ translator={translator} />
      </section>
      <section id="step-by-step-guide">
        <Stack
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "white",
          }}
          pt={5}
          px={7}
        >
          <Typography variant="h3" color={"#00AAB0"}>
            {translator("landingPage.Navigating the Niyel Tracker")}
          </Typography>
          <Typography variant="h5" mt={1}>
            {translator("landingPage.A STEP-BY-STEP GUIDE")}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"500"} mt={1}>
            {translator(
              "landingPage.Welcome to the Niyel Tracker! Here’s how to navigate the platform and make the"
            )}
          </Typography>
          <Typography variant="h6" color={"#494E54"} fontWeight={"500"} mt={1}>
            {translator("landingPage.most of our rich data sets")}
          </Typography>
          <Stack
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              backgroundImage: 'url("/assets/images/stepbystepBg.jpg")',
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              height: "100dvh",
              width: "100%",
              mx: {
                xs: 2,
                sm: 4,
                md: 7,
                lg: 7,
                xl: 7,
              },
            }}
            mb={10}
            mt={5}
          >
            <Stack
              textAlign={"center"}
              sx={{
                backgroundColor: "white",
                padding: "30px 30px",
                borderRadius: "10px",
              }}
            >
              <div>
                <PlayLandingPageIcon />
              </div>
              <Typography variant="h3">
                {translator(
                  "landingPage.Learn how to navigate our platform easily by"
                )}
              </Typography>
              <Typography variant="h3">
                {translator("landingPage.watching this quick video!")}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </section>
      <Stack
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "white",
          width: "100%",
        }}
        pt={5}
        px={7}
      >
        <Typography variant="h5" color={"#00AAB0"}>
          {translator("landingPage.TIPS")}
        </Typography>
        <Typography variant="h3" mt={1}>
          {translator("landingPage.Additional Tips")}
        </Typography>
        <Stack ml={10} mr={10} sx={{ width: "100%" }}>
          <Stack
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                lg: "row",
                xl: "row",
              },
              borderBottom: "1px solid #E4E7EC",
              width: "100%",
            }}
            mt={5}
          >
            <div>
              <TargetTipsIcon />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Typography variant="h4">
                {translator("landingPage.Customizing Your Search")}
              </Typography>
              <Typography variant="h6" mt={1} fontWeight={"400"}>
                {translator(
                  "landingPage.Use filters to tailor your exploration, comparing data across different time periods and countries."
                )}
              </Typography>
            </div>
          </Stack>
          <Stack
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                lg: "row-reverse",
                xl: "row-reverse",
              },
              justifyContent: "flex-start",
              borderBottom: "1px solid #E4E7EC",
              width: "100%",
            }}
            mt={5}
          >
            <div style={{ marginLeft: "10px" }}>
              <DownloadingTipsIcon />
            </div>
            <div>
              <Typography
                variant="h4"
                sx={{
                  textAlign: {
                    xs: "left",
                    sm: "left",
                    lg: "right",
                    xl: "right",
                  },
                }}
              >
                {translator("landingPage.Downloading")}
              </Typography>
              <Typography variant="h6" mt={1} fontWeight={"400"}>
                {translator(
                  "landingPage.Utilize our download and sharing features to save and distribute your findings."
                )}
              </Typography>
            </div>
          </Stack>
          <Stack
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                lg: "row",
                xl: "row",
              },
              borderBottom: "1px solid #E4E7EC",
              width: "100%",
            }}
            mt={5}
          >
            <div>
              <StayUpdatedIcon />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Typography variant="h4">
                {translator("landingPage.Staying Updated")}
              </Typography>
              <Typography variant="h6" mt={1} fontWeight={"400"}>
                {translator(
                  "landingPage.Visit regularly for new data and insights as we continue to expand the Niyel Trackers coverage."
                )}
              </Typography>
            </div>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "10px",
          position: "relative",
          backgroundImage: 'url("/assets/images/backgroundGetStarted.png")',
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          mx: {
            xs: 2,
            sm: 4,
            md: 7,
            lg: 7,
            xl: 7,
          },
        }}
        px={8}
        py={5}
        mb={10}
        mt={5}
      >
        <Typography
          variant="h3"
          color={"white"}
          mt={3}
          className="landing-page-sub-footer"
        >
          {translator("landingPage.Ready to Get Started?")}
        </Typography>
        <Link
          to="/dashboard"
          style={{
            backgroundColor: "white",
            padding: "8px 12px",
            color: "#F6A000",
            borderRadius: "10px",
            fontSize: "14px",
            textDecoration: "none",
            marginTop: "12px",
          }}
        >
          {/* {translator("landingPage.GO TO DASHBOARD")} */}
          {translator("landingPage.Let's Start")}
        </Link>
      </Stack>
      <FooterPublic />
    </div>
  );
}

export { LandingPage };
